import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { MOBILE_CHART_HEIGHT } from '../utils/costingHelpers';

const MobileChartWrapper = ({ children }) => {
    const wrapperRef = useRef(null);
    const [width, setWidth] = useState(0);

    useEffect(() => {
        const el = wrapperRef.current;
        if (!el) return;

        setWidth(el.clientWidth);

        const observer = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const w = entry.contentRect.width;
                if (w > 0) setWidth(w);
            }
        });
        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    return (
        <div className="mobile-chart-wrapper" ref={wrapperRef}>
            {width > 0 && React.Children.map(children, child =>
                React.isValidElement(child)
                    ? React.cloneElement(child, {
                        containerHeight: MOBILE_CHART_HEIGHT,
                        containerWidth: width
                    })
                    : child
            )}
        </div>
    );
};

MobileChartWrapper.propTypes = {
    children: PropTypes.node.isRequired
};

export default MobileChartWrapper;
